import { render } from "./imageMessage.vue?vue&type=template&id=280fc699"
import script from "./imageMessage.vue?vue&type=script&lang=js"
export * from "./imageMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__